import React from "react";
import SubmitFilters from "../components/filters/SubmitFilters";
import DateRangeInput from "../components/inputs/DateRangeInput";
import SearchInput from "../components/inputs/SearchInput";

const Filters = (props) => {
	return (
		<SubmitFilters {...props}>
			<SearchInput source="q" alwaysOn fullWidth />
			<DateRangeInput
				source="view"
				displayedFilters={props.displayedFilters}
				filterValues={props.filterValues}
				setFilters={props.setFilters}
				alwaysOn
				fullWidth
				box={{
					mr: 0,
				}}
			/>
		</SubmitFilters>
	);
};
export default Filters;
